export const TIMEOUT = 60000;
export const DEFAULT_DATE_FORMAT = 'D MMM YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'D MMM YYYY - HH:mm';
export const DASHBOARD_DATE_TIME_FORMAT = 'D MMM YYYY \n HH:mm';
